import { useForm } from "react-hook-form";
import { AddPatientMode } from "./constants";
import { createPatientSchema, linkPatientSchema } from "./schemas";
import { zodResolver } from "@hookform/resolvers/zod";

export function useAddPatientForm({
  mode,
  validate,
  t,
}: {
  mode: AddPatientMode;
  validate: any;
  t: any;
}) {
  const schema =
    mode === AddPatientMode.LINK
      ? linkPatientSchema(t)
      : createPatientSchema(t, validate);

  return useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      FullName: "",
      PhoneNumber: "",
      Birthday: "",
      Gender: "",
    },
  });
}
